















import { Component, Vue } from "vue-property-decorator";
import GalleryFolderRecuclerList from "@/components/tables/gallery/gallery-folder-recucler-list.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

import { ICategory } from "@/@types/gallsery/gallery";
import axios from "@/api/AuthAPI/auth-request-api";
import { gallerys } from "@/config/host.config";
import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";

@Component({
  components: {
    GalleryFolderRecuclerList,
    ButtonBack,
  },
})
export default class FoldersRecucler extends Vue {
  categorys: Array<ICategory> = [];

  updateCategory(id: string): void {
    for (let i = 0; i < this.categorys.length; i++) {
      if (id == this.categorys[i]._id) {
        this.categorys.splice(i, 1);
        this.$emit("start");
        return;
      }
    }
  }

  async getGalleryCategorys(
    uri: string,
    config: AxiosRequestConfig
  ): Promise<Array<ICategory>> {
    return new Promise<Array<ICategory>>((res, rej) => {
      axios
        .get(uri, config)
        .then((response: AxiosResponse) => {
          if (response.status === 200) res(response.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  createGalleryDeletedCategorys(): void {
    const uri = gallerys.categotys;
    const config: AxiosRequestConfig = {
      params: { "match[deleted][value]": true },
    };
    this.getGalleryCategorys(uri, config)
      .then((categorys: Array<ICategory>) => {
        this.categorys = categorys;
      })
      .catch((e: AxiosError) => {
        console.log(e);
      });
  }

  mounted(): void {
    this.createGalleryDeletedCategorys();
  }
}
